export const imageUrl = (pathname: string) =>
  `${process.env.CVNA_APP_CDN_URL}/traffic-assets/vending-machine-assets/${pathname}?auto=webp`;

export const imageUrlFormatPjpg = (pathname: string) =>
  `${process.env.CVNA_APP_CDN_URL}/traffic-assets/vending-machine-assets/${pathname}?format=pjpg&auto=webp`;
